/**
 * Returns 2-letter initials from a name string.
 * "Adam Munir" → "AM", "Adam" → "AD", "" → "?"
 */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter((p) => p.length > 0);
  if (parts.length === 0) return "?";
  if (parts.length === 1) {
    const first = parts[0] ?? "";
    return first.substring(0, 2).toUpperCase();
  }
  return (
    (parts[0]?.[0] ?? "") + (parts[parts.length - 1]?.[0] ?? "")
  ).toUpperCase();
}
